import { render, staticRenderFns } from "./RetentionAdminPanel.vue?vue&type=template&id=1a7c780b&scoped=true&"
import script from "./RetentionAdminPanel.vue?vue&type=script&lang=js&"
export * from "./RetentionAdminPanel.vue?vue&type=script&lang=js&"
import style0 from "./RetentionAdminPanel.vue?vue&type=style&index=0&id=1a7c780b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c780b",
  null
  
)

export default component.exports